module.exports = __webpack_public_path__ + "static/media/Jumbo_Financing.2b7ba2aa.png";